import React, { useState, useEffect, useContext } from 'react'
import firebase from 'firebase'
import { Link, Redirect } from 'react-router-dom'
import SetUserId from '../SignInUp/SetUserId'
import { UserContext } from '../../App'
import style from './user.module.css'
function User() {
    const user = useContext(UserContext)
    const [linkId, setLinkId] = useState('')
    const [isNewUser, setIsNewUser] = useState(false)
    const sty = { transform: 'underline', color: "blue", '&hover': { cursor: "pointer" } }

    useEffect(() => {
        let isSubscribed = true;
        if (user !== null) {
            firebase.database().ref('users').child(user.uid).child('linkid').get()
                .then(s => {
                    if (isSubscribed) { setLinkId(s.val()) }
                    if (s.val() === user.uid.toString() && isSubscribed) {
                        setIsNewUser(true)
                    }
                })

        }
        return () => { isSubscribed = false }
    }, [user])

    const Out = e => {
        e.preventDefault()
        if (user !== null)
            firebase.auth().signOut().then(s => {
                alert("SignedOut")
                window.location.href = "/"
            }).catch(err => alert(err.message))
    }
    return (
        <>
            <div className='text-primary'>
                <SetUserId show={isNewUser} />
                {

                    user === null ?
                        <div>
                            <Link to='/signin' >SignIn to continue</Link>
                        </div>
                        :
                        <div className={style.main}>
                            <div className={style.container1}>
                                <img className={style.user_element} height="120px" style={{ borderRadius: "100px" }} src={user.photoURL} alt="display picture" />
                                <h2 className={style.user_element}>{user.displayName.toUpperCase()}</h2>
                                <div className={style.box}>
                                    <h3 >
                                        Your Link-id {" "}
                                    </h3>
                                    <div className="m-1" style={{ borderBottom: "1px solid #999", width: "300px", paddingTop: "1px", background: "#999" }} />
                                    <h5><Link to={`/${linkId}`}>{`https://localhost:3000/${linkId}`}</Link></h5>
                                </div>
                                <div className={style.user_element}>
                                    <button id={style.idid} className='btn btn-primary mt-3' onClick={Out}>Signout</button>
                                </div>
                            </div>
                        </div>
                }
            </div>

        </>
    )
}
export default User
